import { BdtClaseModel } from "./bdt-clase.model";
import { BdtElementoModel } from "./bdt-elemento.model";
import { BdtImagenesEquipamiento } from "./bdt-imagenes-equipamiento.model";
import { BdtMarcaModel } from "./bdt-marca.model";
import { BdtModeloModel } from "./bdt-modelo.model";
import { BdtResiduoModel } from "./bdt-residuo.model";
import { EmplazamientoModel } from "./btd-emplazmiento-equipamiento.model";

export class BdtEquipamientoModel {
    Id: number;
    Codigo: string;
    CapacidadLitros: number;
    capacidad_litros: number;
    CapacidadKilos: number;
    capacidad_kilos: number;
    CargaMaximaAutorizada: number;
    AlturaLibre: number;
    Tara: number;
    Ancho: number;
    Largo: number;
    Coste: number;
    AnyoVida: number;
    PrecioCompra: number;
    AnyoAmortizacion: number;
    MantenimientoActual: number;
    TiempoRecogida: string; // 00:00:00
    AreaInfluencia: number;
    Icono: string;
    IdMarca: number;
    IdModelo: number;
    IdResiduo: number;
    IdElemento: number;
    Clases: BdtClaseModel[];
    Residuo: BdtResiduoModel;
    Residuos: BdtResiduoModel[];
    residuos: BdtResiduoModel[];
    Modelo: BdtModeloModel;
    modelo: BdtModeloModel;
    Marca: BdtMarcaModel;
    marca: BdtMarcaModel;
    Elemento: BdtElementoModel;

    // Agregados
    Capacidad: number;
    ResiduosNombres: string;
    ClasesNombre: string;

    NumeroFracciones: number;
    Pedal: boolean;
    Emplazamientos: string;
    Diametro: number;
    AlturaSensor: number;
    GradosSensor: number;
    AlturaMuerta: number;
    CoeficienteConversion: number;
    MantenimmientoAnual: number;
    IdsElementos: number[] = []; // Ids de los elementos creados de este tipo
    Imagenes: BdtImagenesEquipamiento[] = [];
    Emplazamiento: EmplazamientoModel;

    //Modificacion ficha elemento
    TipoMaterial: string;
    Ruedas: boolean;
    Altura: number;
    AnchoInterior: number;
    AltoInterior: number;
}
